const styles = (theme) => ({
  root: {},
  title: {
    borderBottom: `1px solid ${theme.palette.primary.dark}`,
    paddingBottom: theme.spacing.unit * 2,
    position: 'relative',
  },
  edit: {
    '&&': {
      position: 'absolute',
      top: '-6px',
      right: 0,
      minHeight: 0,
      minWidth: 0,
      padding: 0,
      color: theme.palette.primary.dark,
    },
  },
  avatar: {
    marginTop: '0px',
    [theme.breakpoints.up('md')]: {
      marginTop: '10px',
    },
    color: theme.palette.custom.details,
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  negativeTopMargin: {
    // Use negative margin to counter-act the displacement caused by the avatar
    [theme.breakpoints.up('md')]: {
      marginTop: '-30px',
    },
  },
  heading: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'flex-start',
  },
  updating: {
    color: theme.palette.primary.dark,
    fontSize: '1.0625',
    fontWeight: 500,
    paddingRight: theme.spacing.unit / 2,
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.125rem',
    },
  },
});

export default styles;
